import { Component } from '@angular/core';
import { AlertController,ToastController,ModalController, NavParams, ViewController } from 'ionic-angular';
import { FormBuilder, FormGroup,Validators } from '@angular/forms';
import { Params } from '../params';
import * as firebase from 'firebase/app';

@Component({
  selector: 'page-gingredients',
  templateUrl: 'groupingredients.html'
})
export class GroupIngredientsPage{
  ingredients = [];
  constructor(
    public modalCtrl: ModalController,
    public params: NavParams,

  ){
   /*  this.ingredientsRef = af.list('/groupingredients');
    this.ingredientsRef.subscribe(x => {
      x = x.filter((item) => {return (item.deleted==undefined || !item.deleted);});
      this.ingredients = x;
    }); */

  }
  newItem(i){
    let modal = this.modalCtrl.create(GroupIngredientPage, {item:i,ing:this.params.get("ing")});
    modal.present();
  }
}

@Component({selector: 'page-gingredient', templateUrl: 'groupingredient.html'})
export class GroupIngredientPage {
  ingredients = [];
  title;
  addForm: FormGroup;
  edit:boolean = false;
  constructor(
    public params: NavParams,
    public viewCtrl: ViewController,
    private builder: FormBuilder,
    public toastCtrl: ToastController
  ) {

    this.addForm = builder.group({
      'key': ['', Validators.required],
      'name': ['', Validators.required],
      'ingredients' : [[], Validators.required]
    })
    this.ingredients = this.params.get("ing");
    this.title = "Nuevo Grupo";
    console.log(this.ingredients);
    if(this.params.get("item")){
      let ingredient = this.params.get("item");
      this.edit = true;
      this.title = "Editar Grupo";
      this.addForm = builder.group({
        'key': [ingredient["key"], Validators.required],
        'name': [ingredient["name"], Validators.required],
        'ingredients': [ingredient["ingredients"]]
      });
    }
  }


  save() {
    console.log(this.addForm.value);
    this.addForm.value.deleted = false;
    let key = Params.key_parse(this.addForm.value["key"]);
    this.addForm.value.key = key;
    //this.ingredient = this.db.object('groupingredients/'+key);
    let msg = 'Grupo de Ingredientes '+this.addForm.value.name+' creado exitosamente';
    if(this.edit){
      msg = 'Grupo de Ingredientes '+this.addForm.value.name+' editado exitosamente';
      /* this.ingredient.set(this.addForm.value).then(_ => {
        let toast = this.toastCtrl.create({
          message: msg,
          duration: 3000
        });
        toast.present();
      }); */

      this.viewCtrl.dismiss();
    }else{
      firebase.database().ref('groupingredients/'+key).once('value')
        .then((snap)=> {
          if (snap.exists()) {
            let toast = this.toastCtrl.create({
              message: 'El código '+key+' ya está siendo utilizado para un grupo. Utilice otro.',
              duration: 3000
            });
            toast.present();
          }else{
            /* this.ingredient.set(this.addForm.value).then(_ => {
              let toast = this.toastCtrl.create({
                message: msg,
                duration: 3000
              });
              toast.present();
            }); */

            this.viewCtrl.dismiss();
          }
        })
    }

  }
}



// WEBPACK FOOTER //
// ./src/pages/ingredients/groupingredients.ts